export default {
  getTransactionHistory: ({ transactionHistoryData }) => transactionHistoryData,
  getTradeHistory: ({ tradeHistory }) => tradeHistory,
  getOrderHistory: ({ orderHistory }) => orderHistory,
};